import _, { cloneDeep } from "lodash";
import React from "react";
import { Table, Form, Button } from "react-bootstrap";
import jsDig from "utils/jsDig";

// TODO: make metrics calculated metrics calculatable
export default function GoalsTable(props) {
  let calculatorLarge = require("images/icons/calculator-large.png");
  calculatorLarge = <img className="calculator" src={`/datapulse${calculatorLarge}`} />;
  let calculatedMetric = [];
  switch (props.service) {
    case "ppc":
      calculatedMetric = ["cpv", "viewRate", "viewCtr", "viewableCtr", "shopifyRoas", "shopifySubtotalRoas", "clickRoas", "totalRoas", "cpc", "ctr", "cvr", "videoCvr", "clickCpa", "totalCpa", "clickAov", "totalAov", "clickConversions", "clickRevenue", "totalConversions", "totalRevenue"];
      break;
    case "search":
      calculatedMetric = ["clickRoas", "cpc", "ctr", "cvr", "clickCpa", "clickAov", "clickConversions", "clickRevenue"];
      break;
    case "social":
      calculatedMetric = ["viewCtr", "clickRoas", "totalRoas", "viewRate", "cpc", "viewCtr", "ctr", "cvr", "clickCpa", "totalCpa", "clickAov", "totalAov", "clickConversions", "clickRevenue", "totalConversions", "totalRevenue"];
      break;
    case "display":
      calculatedMetric = ["cpsv", "clickRoas", "totalRoas", "cpc", "ctr", "cvr", "clickCpa", "totalCpa", "clickAov", "totalAov", "clickConversions", "clickRevenue", "totalConversions", "totalRevenue"];
      break;
    case "video":
      calculatedMetric = ["cpv", "viewRate", "viewCtr", "viewableCtr", "clickRoas", "totalRoas", "cpc", "ctr", "cvr", "videoCvr", "clickCpa", "totalCpa", "clickAov", "totalAov", "clickConversions", "clickRevenue", "totalConversions", "totalRevenue"];
      break;
  }
  const metricCalculation = (e, metric, month) => {
    e.preventDefault();
    let newDashboards = props.dashboards;
    const thisMonth = newDashboards[props.index]["goals"][props.year][month];
    switch (metric) {
      case "cpc":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["spend"] / thisMonth["clicks"]).toFixed(2);
        break;
      case "cpv":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["spend"] / thisMonth["views"]).toFixed(2);
        break;
      case "cpsv":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["spend"] / thisMonth["inStoreVisits"]).toFixed(2);
        break;
      case "ctr":
        newDashboards[props.index]["goals"][props.year][month][metric] = ((thisMonth["impressions"] / thisMonth["clicks"]) * 100).toFixed(2);
        break;
      case "cvr":
        newDashboards[props.index]["goals"][props.year][month][metric] = ((thisMonth["clickConversions"] / thisMonth["clicks"]) * 100).toFixed(2);
        break;
      case "videoCvr":
        newDashboards[props.index]["goals"][props.year][month][metric] = ((thisMonth["totalConversions"] / thisMonth["views"]) * 100).toFixed(2);
        break;
      case "clickCpa":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["spend"] / thisMonth["clickConversions"]).toFixed(2);
        break;
      case "totalCpa":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["spend"] / thisMonth["totalConversions"]).toFixed(2);
        break;
      case "clickRevenue":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["clickRoas"] * thisMonth["spend"]).toFixed(0);
        break;
      case "totalRevenue":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["totalRoas"] * thisMonth["spend"]).toFixed(0);
        break;
      case "clickConversions":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["spend"] / thisMonth["clickCpa"]).toFixed(0);
        break;
      case "totalConversions":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["spend"] / thisMonth["totalCpa"]).toFixed(0);
        break;
      case "clickRoas":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["clickRevenue"] / thisMonth["spend"]).toFixed(2);
        break;
      case "totalRoas":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["totalRevenue"] / thisMonth["spend"]).toFixed(2);
        break;
      case "shopifyRoas":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["shopifyRevenue"] / thisMonth["spend"]).toFixed(2);
        break;
      case "shopifySubtotalRoas":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["shopifySubtotalRevenue"] / thisMonth["spend"]).toFixed(2);
        break;
      case "viewRate":
        props.service == "social"
          ? (newDashboards[props.index]["goals"][props.year][month][metric] = ((thisMonth["views"] / thisMonth["impressions"]) * 100).toFixed(2))
          : (newDashboards[props.index]["goals"][props.year][month][metric] = ((thisMonth["views"] / thisMonth["viewableImpressions"]) * 100).toFixed(2));
        break;
      case "viewRate":
        newDashboards[props.index]["goals"][props.year][month][metric] = ((thisMonth["views"] / thisMonth["viewableImpressions"]) * 100).toFixed(2);
        break;
      case "viewCtr":
        newDashboards[props.index]["goals"][props.year][month][metric] = ((thisMonth["clicks"] / thisMonth["views"]) * 100).toFixed(2);
        break;
      case "viewableCtr":
        newDashboards[props.index]["goals"][props.year][month][metric] = ((thisMonth["clicks"] / thisMonth["viewableImpressions"]) * 100).toFixed(2);
        break;
      case "clickAov":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["clickRevenue"] / thisMonth["clickConversions"]).toFixed(2);
        break;
      case "totalAov":
        newDashboards[props.index]["goals"][props.year][month][metric] = (thisMonth["totalRevenue"] / thisMonth["totalConversions"]).toFixed(2);
        break;
    }
    props.setDashboards([...newDashboards]);
  };
  return (
    <>
      {props.metricList && props.checkedMetrics && props.checkedMetrics.length > 0 ? (
        <div className="goals-table px-0 px-md-3">
          <div className="table-responsive pb-3">
            <Table>
              <thead>
                <tr>
                  <th width="100px"></th>
                  {props.checkedMetrics.map((metricName) => {
                    const metric = props.metricList[metricName];
                    if (metric) {
                      return (
                        <th key={metricName} className="goal-col">
                          <p className="f16 pl-2 light-primary nunito-regular normal text-center text-md-left">{jsDig(["name", "title"], metric)}</p>
                        </th>
                      );
                    }
                  })}
                </tr>
              </thead>
              <tbody>
                {moment.monthsShort().map((month) => {
                  return (
                    <tr key={month}>
                      <th>
                        <p className="f16 light-primary nunito-regular normal">{`${month}.`}</p>
                      </th>
                      {props.checkedMetrics.map((metricName) => {
                        const metric = props.metricList[metricName];
                        let newGoals = props.goals;
                        if (props.onboarding && props.goals && props.setGoals) {
                          // Populate with empty strings so we can save to db even if the input was not filled out
                          newGoals[props.service][props.dashboard.id][props.year] = newGoals[props.service][props.dashboard.id][props.year] || {};
                          newGoals[props.service][props.dashboard.id][props.year][month] = newGoals[props.service][props.dashboard.id][props.year][month] || {};
                          newGoals[props.service][props.dashboard.id][props.year][month][metricName] =
                            newGoals[props.service][props.dashboard.id][props.year][month][metricName] || "";
                        }
                        if (metric) {
                          return (
                            <td key={metricName}>
                              <span style={{ height: "32px", display: "block" }}>
                                <Form.Control
                                  style={{ textAlign: "center" }}
                                  size="sm"
                                  name={`[goals][${props.service}][${props.dashboard.id}][${props.year}][${month}][${metricName}]`}
                                  value={
                                    jsDig(["goals", props.year, month, metricName], props.dashboard)
                                      ? jsDig(["goals", props.year, month, metricName], props.dashboard)
                                      : ""
                                  }
                                  type="number"
                                  step=".01"
                                  onChange={
                                    props.onboarding && props.goals && props.setGoals
                                      ? (e) => {
                                          newGoals[props.service][props.dashboard.id][props.year][month][metricName] = e.target.value;
                                          props.setGoals({ ...newGoals });
                                        }
                                      : (e) => {
                                          let newDashboards = props.dashboards;
                                          newDashboards[props.index]["goals"][props.year][month][metricName] = e.target.value;
                                          props.setDashboards([...newDashboards]);
                                        }
                                  }
                                />
                                {calculatedMetric.includes(metricName) ? (
                                  <button
                                    style={{ position: "relative", background: "transparent", top: "-30px" }}
                                    onClick={(e) => metricCalculation(e, metricName, month)}>
                                    {calculatorLarge}
                                  </button>
                                ) : (
                                  <button style={{ position: "relative", background: "transparent", top: "-30px" }} />
                                )}
                              </span>
                            </td>
                          );
                        }
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      ) : (
        <>
          <Form.Control hidden name={`[goals][${props.service}][${props.dashboard.id}][${props.year}][]`} />
          <p>You don't have any metrics selected.</p>
        </>
      )}
    </>
  );
}
// The first rule about GoalsTable.jsx... we don't talk about GoalsTable.jsx
